import React from 'react';
import { CircleCheckIcon, FilledDeleteIcon } from 'design-system';
import useTextInputStyles from '../../styles/useTextInputStyles';

export default function useDefaultInputHook(
  error: boolean,
  defaultValue: string,
): {
  currentClass: string;
  decoration: JSX.Element;
  onInputChanged: (stringValue: string) => void;
  onBlur: () => void;
} {
  const classes = useTextInputStyles();
  const [currentClass, updateCurrentClass] = React.useState<string>(
    classes.defaultCustomInput,
  );
  const [decoration, setDecoration] = React.useState<JSX.Element>(<div />);

  const onInputChanged = (stringValue: string): void => {
    if (stringValue !== '') {
      setDecoration(<FilledDeleteIcon />);
    } else {
      setDecoration(<div />);
    }
  };

  const onBlur = (): void => {
    if (error) {
      setDecoration(<FilledDeleteIcon />);
      updateCurrentClass(classes.errorCustomInput);
    } else if (defaultValue !== '') {
      setDecoration(<CircleCheckIcon />);
      updateCurrentClass(classes.correctCustomInput);
    } else {
      setDecoration(<div />);
      updateCurrentClass(classes.defaultCustomInput);
    }
  };

  return {
    currentClass,
    decoration,
    onInputChanged,
    onBlur,
  };
}
